import Image, { ImageProps } from 'next/image';
import styled from 'styled-components';

const AutoHeightImage = ({ ...props }: ImageProps) => {
  return (
    <ImageWrapper>
      <Image {...props} alt={'image'} layout={'fill'} className={'autoImage'} />
    </ImageWrapper>
  );
};

export default AutoHeightImage;

const ImageWrapper = styled.div`
  width: 100%;

  & > span {
    position: unset !important;
    & .autoImage {
      object-fit: contain !important;
      position: relative !important;
      height: auto !important;
    }
  }
`;
